import React, { useEffect } from 'react'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { FormikDropdownField } from 'components/form/Dropdown'
import { FormikInputField } from 'components/form/InputField'
import { Grid } from '@material-ui/core'
import { adminAgeGroups, adminSexes, adminRaces } from 'admin/actions/admin_dropdown_options'

export const validationSchema = Yup.object().shape({
  age_group: Yup.string().required('Age group is required'),
  sex: Yup.string().required('Sex is required'),
  race: Yup.string().required('Race is required'),
  number_of_people: Yup.number()
    .transform((v, o) => (o === '' ? undefined : v))
    .min(0, 'Must be 0 or more')
    .required('Number of people is required')
})

export default function AdminBeneficiaryVettingDemographicForm({ formik_props }) {
  const dispatch = useDispatch()
  const age_group_options = useSelector(() => adminAgeGroups.getAsOptions())
  const sex_options = useSelector(() => adminSexes.getAsOptions())
  const race_options = useSelector(() => adminRaces.getAsOptions())

  useEffect(() => {
    dispatch(adminAgeGroups.fetchListIfNeeded())
    dispatch(adminSexes.fetchListIfNeeded())
    dispatch(adminRaces.fetchListIfNeeded())
  }, [dispatch])

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12}>
        <FormikDropdownField
          name="race"
          label="Race"
          options={race_options || []}
          formik_props={formik_props}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormikDropdownField
          name="sex"
          label="Sex"
          options={sex_options || []}
          formik_props={formik_props}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormikDropdownField
          name="age_group"
          label="Age Group"
          options={age_group_options || []}
          formik_props={formik_props}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormikInputField
          name="number_of_people"
          label="Number of People"
          type="number"
          formik_props={formik_props}
          inputProps={{ min: 0 }}
        />
      </Grid>
    </Grid>
  )
}
